import type { ReactFlowInstance } from 'reactflow';

export const unselectAllNodes = (reactFlowInstance: ReactFlowInstance) => {
  const setNodes = reactFlowInstance.setNodes;

  setNodes((nds) => nds.map((node => ({ ...node, selected: false }))));
}
